/** Port von `Client/Pages/Views/IwmViewRechnungszuordnung.razor`. */

import { receiptAssignmentApi } from '@/api/services/receiptAssignmentApi';
import { receiptAssignmentCellTemplates } from '@/components/columns/receiptAssignmentColumns';
import type { CellTemplateMap } from '@/components/columns/types';
import { DataGrid } from '@/components/grid/DataGrid';
import { useSidebar } from '@/components/sidebars/useSidebar';
import { AuditButton } from '@/components/views/AuditButton';
import { DeleteButton } from '@/components/views/DeleteButton';
import { ExcelExportButton } from '@/components/views/ExcelExportButton';
import { ViewAuditSidebar } from '@/components/views/ViewAuditSidebar';
import { ViewPageFrame } from '@/components/views/ViewPageFrame';
import { useViewIdParam } from '@/components/views/useViewIdParam';
import { useViewPage } from '@/hooks/useViewPage';
import type { ReceiptAssignment } from '@/types/entities';
import { EntityTypes } from '@/types/enums';

/** `SetColumnEditTemplates` ist hier vollständig auskommentiert. */
const NO_EDIT_TEMPLATES: CellTemplateMap<ReceiptAssignment> = {};

export function ReceiptAssignmentView() {
  const viewId = useViewIdParam();
  const page = useViewPage<ReceiptAssignment>({
    viewId,
    entity: EntityTypes.Rechnungszuordnung,
    api: receiptAssignmentApi,
    cellTemplates: receiptAssignmentCellTemplates,
    editTemplates: NO_EDIT_TEMPLATES,
  });
  const { permissions, selectedId, view } = page;

  const auditSidebar = useSidebar();

  const toolbar = (
    <>
      {permissions?.AllowAudit === true ? (
        <AuditButton
          selectedId={selectedId}
          onClick={() => {
            auditSidebar.show();
          }}
        />
      ) : null}
      {permissions?.AllowDelete === true ? (
        <DeleteButton selectedId={selectedId} onClick={() => page.deleteSelected()} />
      ) : null}
      <ExcelExportButton running={page.excelExportRunning} onClick={() => page.exportExcel()} />
    </>
  );

  return (
    <>
      <ViewPageFrame view={view} gridClassName="view-grid-Receipt" toolbar={toolbar}>
        <DataGrid<ReceiptAssignment>
          ref={page.gridRef}
          id={`grid-rechnungszuordnung-${view?.ViewName ?? ''}`}
          columns={page.columns}
          view={view}
          dataSource={page.dataSource}
          onCellSave={(item, columnName) => page.saveCell(item, columnName)}
          onSelectedIdChange={(id) => {
            page.setSelectedId(id);
          }}
        />
      </ViewPageFrame>

      {permissions?.AllowAudit === true ? (
        <ViewAuditSidebar
          entity={EntityTypes.Rechnungszuordnung}
          viewId={viewId}
          selectedId={selectedId}
          open={auditSidebar.visible}
          onClose={() => {
            auditSidebar.hide();
          }}
        />
      ) : null}
    </>
  );
}

export default ReceiptAssignmentView;
